var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrayPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#B7CCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4275 10.5C17.4275 12.4332 15.8926 14 13.9989 14C12.1051 14 10.5703 12.4332 10.5703 10.5C10.5703 8.56679 12.1051 7 13.9989 7C15.8926 7 17.4275 8.56679 17.4275 10.5ZM11.4297 10.5C11.4297 11.9465 12.5841 13.125 14.0011 13.125C15.4181 13.125 16.5725 11.9465 16.5725 10.5C16.5725 9.0535 15.4181 7.875 14.0011 7.875C12.5841 7.875 11.4297 9.0535 11.4297 10.5ZM18.7143 21C19.4241 21 20 20.4121 20 19.6875V18.55C20 16.5211 18.3875 14.875 16.4 14.875C16.063 14.875 15.8027 14.9591 15.5103 15.0535C15.1357 15.1745 14.7085 15.3125 14 15.3125C13.292 15.3125 12.8658 15.1747 12.4917 15.0538C12.1992 14.9592 11.9385 14.875 11.6 14.875C9.61251 14.875 8 16.5211 8 18.55V19.6875C8 20.4121 8.57589 21 9.28571 21H18.7143ZM9.28795 20.125H18.7165C18.9522 20.125 19.1451 19.9281 19.1451 19.6875V18.55C19.1451 17.0051 17.9156 15.75 16.4022 15.75C16.2006 15.75 15.9989 15.8145 15.7506 15.894C15.3522 16.0215 14.8337 16.1875 14.0022 16.1875C13.1688 16.1875 12.6506 16.0214 12.2527 15.8939C12.0049 15.8145 11.8038 15.75 11.6022 15.75C10.0889 15.75 8.85938 17.0051 8.85938 18.55V19.6875C8.85938 19.9281 9.05224 20.125 9.28795 20.125Z",
    fill: "#081E54"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayPerson);
export default __webpack_public_path__ + "static/media/GrayPerson.5d20c21baa4fbb19bee9b913b3f16a7f.svg";
export { ForwardRef as ReactComponent };